// Shared sessionStorage flag for the inactivity lock, kept in its own
// module so auth plumbing (useAuth's logout, AuthProvider's post-redirect
// processing) can read/clear it without importing the IdleLock component
// (which would create an import cycle through useAuth).
//
// The flag is set when the idle timer fires (IdleLock) and cleared in
// exactly two places:
//   1. AuthProvider — after a successful interactive sign-in returns
//      from Microsoft (a fresh sign-in is at least as strong as the
//      lock's password re-verification).
//   2. useAuth's logout() — so a signed-out user isn't instantly
//      re-locked on their next sign-in. A stale flag here was the cause
//      of an endless "sign in → immediately locked again" loop
//      (July 2026).
export const LOCK_FLAG_KEY = 'portal-idle-locked';

export function isIdleLocked() {
  return sessionStorage.getItem(LOCK_FLAG_KEY) === '1';
}

export function setIdleLocked() {
  sessionStorage.setItem(LOCK_FLAG_KEY, '1');
}

export function clearIdleLock() {
  sessionStorage.removeItem(LOCK_FLAG_KEY);
}
